
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-health",
      function () {
        return require("private-next-pages/public-health.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-health"])
      });
    }
  